import { Row } from 'style/preset'
import styled, { css } from 'styled-components'
import { ReactComponent as WarnSvg } from 'assets/svgs/waring_icon.svg' 

interface Props {
    desc?: string;
    isError?: boolean;
    bgColor?: string
}

const WarnBarCom = ({isError = false, desc = '', bgColor = '#F6F5F4'}: Props) => {
    return <>
        <WarningBarWrap $isError={isError} $bgColor={bgColor}>
            <WarnSvgWrap></WarnSvgWrap>
            {desc}
        </WarningBarWrap>
    </>
}

const WarningBarWrap = styled(Row)<{$isError: boolean, $bgColor: string}>`
    display: inline-flex;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    padding: 8px 10px;
    background-color: ${({$bgColor}) => $bgColor};
    border-radius: 6px;

    ${
        ({$isError, theme}) => $isError ? css`
            background-color: #E000E0;
            color: ${theme.basicWhite};
            ${WarnSvgWrap} {
                rect, path {
                    fill: ${theme.basicWhite}
                }
            }
        ` : css`
            ${WarnSvgWrap} {
                rect, path {
                    fill: ${theme.basicBlack}
                }
            }
        `
    }
`

const WarnSvgWrap = styled(WarnSvg)`
    width: 14px;
    height: 14px;
    margin-right: 8px;
`

export default WarnBarCom